import {SquareTileIcon} from "./squareTileIcon/SquareTileIcon";
import {SquareTileTitle} from "./squareTileTitle/SquareTileTitle";
import {SquareTileDescription} from "./squareTileDescription/SquareTileDescription";
import {ReactElement} from "react";
import './SquareTile.css'
import {Badge, Space} from "antd";
import {SquareTileBadge} from "./squareTileIcon/SquareTileBadge";

export interface SquareTileProps {
    title: string;
    description: string;
    icon: ReactElement<any, any>;
    onCLick: () => void
    hide?: boolean
    count?: number;
    className?: string;
}

export function SquareTile(props: SquareTileProps) {
    return (
        <>
            {!props.hide && (
                <div className={`square-tile ${props.className || ''}`} onClick={props.onCLick}>
                    <SquareTileBadge count={props.count} title={props.title}  />

                    <SquareTileIcon icon={props.icon} />

                    <Space direction="horizontal" style={{width: '100%', justifyContent: 'center'}}>
                        <SquareTileTitle title={props.title} />
                    </Space>

                    <Space direction="horizontal" style={{width: '100%', justifyContent: 'center'}}>
                        <SquareTileDescription description={props.description} />
                    </Space>
                </div>
            )}
        </>
    );
}


